<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <b-table :data="model"
                 :loading="loading"
                 :bordered="true"
                 striped
                 hoverable
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGINAANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGINAATUAL')"
                 backend-pagination
                 paginated
                 :per-page="perPage"
                 :total="total">

            <template>
                <b-table-column v-slot="props" field="Id" :label="$t('SISTEMA.CODIGO')" >
                    {{ props.row.clienteCodigoExterno }}
                        <b-icon v-if="props.row.vendaVinculadaId > 0"  icon="link"
                                    size="is-small"                                    
                                    :title="$t('GUIALIST.ATENDIMENTOVINCULADO')"
                                    type="is-link"></b-icon>                     
                </b-table-column>

                <b-table-column v-slot="props" field="CodigoContrato" :label="$t('SISTEMA.CODIGOCONTRATO')" >
                    <template v-if="props.row.codigoContrato">
                        {{ props.row.codigoContrato }}

                        <span v-if="props.row.dataContrato">
                            <br>
                            {{ $moment(props.row.dataContrato).format("DD/MM/YYYY") }}
                        </span>
                        
                    </template>
                </b-table-column>

                <b-table-column v-slot="props" field="ClienteNome" :label="$t('SISTEMA.CLIENTE')" >
                    {{ props.row.cliente }}
                </b-table-column>

                <b-table-column v-slot="props" field="ValorVenda" label="Valor Sem Indicador" >
                    {{ retornarValorFormatado(props.row.valor) }}
                </b-table-column>

                <b-table-column v-slot="props" field="VENDEDOR" :label="$t('SISTEMA.VENDEDOR')" >
                    {{ props.row.vendedor }}
                </b-table-column>

                <b-table-column v-if="fromDashboard == 'Geral'" v-slot="props" field="UNIDADE" :label="$t('SISTEMA.UNIDADE')" >
                    {{ props.row.unidadeNome }}
                </b-table-column>                

                <b-table-column v-if="fromDashboard == 'Projetistas'" v-slot="props" field="Projetista" :label="$t('SISTEMA.PROJETISTA')" >
                    {{ props.row.projetista }}
                </b-table-column>
                <b-table-column v-else-if="fromDashboard == 'Conferentes'" v-slot="props" field="Conferente" :label="$t('SISTEMA.CONFERENTE')" >
                    {{ props.row.conferente }}
                </b-table-column>

                <b-table-column v-slot="props" custom-key="actions" numeric >
                    <router-link :to="{ name: 'guia', params: { id: props.row.guiaId,atualizarUnidadeId: props.row.unidadeId,guiaList:true }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
            <template #footer>
                <th > <div class="th-wrap"> </div> </th>
                <th > <div class="th-wrap"> </div> </th>
                <th > <div class="th-wrap"> </div> </th>
                <th >
                    <div class="th-wrap">  {{ retornarValorTotalVenda() }}  </div>
                </th>
                <th v-if="fromDashboard == 'Projetistas' || fromDashboard == 'Conferentes'" > <div class="th-wrap"> </div> </th>
                <th > <div class="th-wrap"> </div> </th>
                <th > <div class="th-wrap"> </div> </th>
            </template>
        </b-table>

        <nav class="level">
                <div class="level-item">
                    <p class="buttons">
                        <b-button type="is-danger"
                                  native-type="button"
                                  icon-left="close-circle"
                                  @click="voltarTela()">
                            {{$t('SISTEMA.VOLTAR')}}
                        </b-button>
                    </p>
                </div>
            </nav>
    </section>
</template>

<script>
    import titlebar from '@/components/titlebar.vue'
    import debounce from 'lodash/debounce'
    import { mapState, mapGetters } from 'vuex'

    export default {
        data(){
            return {
                model: [],
                total: 0,
                loading: false,
                card: this.$route.query.card ?? '',
                fromDashboard: this.$route.query.fromDashboard ?? '',
                id: null,
                page: 1,
                perPage: 50,
            }
        },
        components: {
            titlebar,
        },
        computed: {
            titleStack() {
                return [
                    this.$t('RELATORIO.RELATORIO'),
                    this.$t('RELATORIO.DASHBOARD'),
                    this.fromDashboard
                ]
            },
            ...mapState([
                'unidadeId',
                'usuario'
            ]),
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
            isAdministrador() {
                return (
                    this.usuario.nivel == "Administrador" || this.usuario.nivel == "Franqueado"                     
                );
            },                 
            voltarTela(){

                if(this.$route.query.fromDashboard == 'Conferentes'){
                    this.$router.push({ name: 'conferentes' , query: {funcionarioId: this.$route.query.funcionarioId  } });                    
                }else if (this.$route.query.fromDashboard == 'Projetistas' ){
                    this.$router.push({ name: 'projetistas' , query: {funcionarioId: this.$route.query.funcionarioId  }});
                }else if (this.$route.query.fromDashboard == 'Vendedores' ){
                    this.$router.push({ name: 'vendedores' , query: {funcionarioId: this.$route.query.funcionarioId  }});
                }else if (this.$route.query.fromDashboard == 'Geral' ){
                    this.$router.push({ name: 'geral'});
                }

            },
            parametroVoltarTela(){
                if(this.$route.query.fromDashboard == 'Conferentes'){
                    return 'conferentes';            
                }else if (this.$route.query.fromDashboard == 'Projetistas' ){
                    return 'projetistas';
                }else if (this.$route.query.fromDashboard == 'Vendedores' ){
                    return 'vendedores';
                }else if (this.$route.query.fromDashboard == 'Geral' ){
                    return 'geral';
                }            
            },
            retornarValorFormatado(valor){
                return valor.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
            },
            retornarValorTotalVenda(){
                let valorTotalVenda = 0.0;
                
                if(this.model && this.model.length > 0)
                    this.model.forEach((item) => valorTotalVenda += item.valor );

                return valorTotalVenda.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                });
            },                   
            loadAsyncData: debounce(function () {
                const params = this.montaParametros();
                    
                this.loading = true;

                const url = `/api/relatorio/DashboardCardList?${params.join('&')}`;
                    
                this.$http.get(url)
                    .then(({ data }) => {
                        this.model = data.lista;
                        this.total = this.perPage * data.pageCount;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    });
            }, 500),
            montaParametros() {
                const params = [                    
                    `page=${this.page}`,
                    `perPage=${this.perPage}`
                ];

                if(this.$route.query.fromDashboard == 'Geral'){
                    if(!this.isAdministrador())
                        params.push(`unidadeId=${this.unidadeId}`)    
                    
                }else{
                    params.push(`unidadeId=${this.unidadeId}`)
                }
               
    
                if(this.$route.query.card){
                    params.push(`cardToList=${this.card}`)
                }

                if(this.$route.query.isProjetista){
                    params.push(`isProjetista=${this.$route.query.isProjetista}`)
                }  
                                
                if(this.$route.query.isVendedor){
                    params.push(`isVendedor=${this.$route.query.isVendedor}`)
                }

                if(this.$route.query.isConferente){
                    params.push(`isConferente=${this.$route.query.isConferente}`)
                }

                if(this.$route.query.funcionarioId){
                    params.push(`funcionarioId=${this.$route.query.funcionarioId}`)
                }
    
                return params;
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
        },
        async mounted() {
            await this.loadAsyncData();
        }
    }
</script>